"use strict";

var Messages = {
  isMiniChat: false,
  chatID: undefined,
  previewFiles: [],
  typeText: 0,
  typeImages: 1,
  typeVideos: 2,
  chatPage: 2,
  pagination: {
    page: 1,
    status: 1
  },
  onload: document.addEventListener('DOMContentLoaded', function () {
    Messages.init();
  }),
  init: function init() {
    this.bind();
    this.scrollToFirstChat();
    this.popupDownloadOurAppsMessenger();
    Main.showHideBlockByCookies('moovick-download-our-app-popup-messenger-to-stay-connected', $('.download-app'), 7);
  },
  scrollToFirstChat: function scrollToFirstChat() {
    var block = $('.chat__list-content');
    if (block.length > 0) {
      block.animate({
        scrollTop: parseInt($('.chat__list__item').first().offset().top) - 250
      }, 500);
    }
  },
  bind: function bind() {
    $(document).on('click', 'div.user-image', function () {
      window.open($(this).attr('data-url'), '_blank');
    }).on('click', 'div.chat__list__item', function () {
      $('div.chat__list__item').removeClass('active');
      $(this).addClass('active');

      // $('div#chat-window').html('');

      Messages.chatID = $(this).attr('id');
      Messages.ajax.openChat($(this));
    }).on('click', 'button#send-message', function (event) {
      event.preventDefault();
      var field = $(this).closest('form').find('textarea');
      var message = field.val().trim();
      if (message.length > 0) {
        $(this).prop('disabled', true);
        Messages.ajax.sendMessage($(this), message, field);
      }
    }).on('click', 'button#send-photos', function (event) {
      event.preventDefault();
      if (Messages.files.list.length > 0) {
        Main.showPreloader($(this));
        Messages.ajax.sendPhotos($(this), parseInt($(this).attr('data-type')));
      }
    }).on('click', '.back-to-chat-lists', function (event) {
      event.preventDefault();
      $('.tab__messages').addClass('active');
      $('.messages__window-active').addClass('active');
      $('.chat__window').removeClass('active');
      $('.chat-info').hide();
    }).on('click', '#load_more_chats', function (e) {
      e.preventDefault();
      e.stopPropagation();
      Main.showPreloader($(this));

      // $('.tab__messages').addClass('active');
      // $('.messages__window-active').addClass('active');
      // $('.chat__window').removeClass('active');

      Messages.ajax.nextChatPage($(this));
    }).on('click', '.tab__messages', function (event) {
      event.preventDefault();
      $('.tab__messages').removeClass('active');
      $('.messages__window-active').removeClass('active');
      $('.chat__window').addClass('active');
      // $('.chat-info').show();
    }).on('click', '.open-mini-chat-for-offer', function (event) {
      event.preventDefault();
      var hash = $(this).closest('.offer-info-item').attr('id');
      Main.showPreloader($(this));
      Messages.ajax.openMiniChatForOffer(hash, $(this));
    }).on('click', 'button.open-mini-chat', function (event) {
      event.preventDefault();
      var userID = $(this).attr('data-user');
      Messages.ajax.openMiniChat(userID);
    }).on('click', '.offer__closed', function (event) {
      $('.mini-chat__tooltip__left').hide();
    }).on('click', '.mini-chat__svg > svg', function (event) {
      $('.mini-chat__tooltip__left').show();
    }).on('click', '.download-app__close', function (event) {
      // $('.download-app').hide();
      // $('.popup-download-app').hide();

      Main.createCookie('moovick-download-our-app-popup-messenger-to-stay-connected', 1, 7);
      Main.showHideBlockByCookies('moovick-download-our-app-popup-messenger-to-stay-connected', $('.download-app'), 7);
    }).on('click', '.messages-download-app__close', function (event) {
      Main.createCookie('moovick-download-our-app-popup-messenger', 1, 7);
      Messages.popupDownloadOurAppsMessenger();
    }).on('click', function (e) {
      console.log(e);
      if (!$(e.target).closest(".send-media__btn").length) {
        $(".send-media-tooltip").removeClass('active');
      }
      e.stopPropagation();
    }).on('input paste', '.messages__send', function (event) {
      var textarea = document.querySelector('.messages__send');
      textarea.style.height = "".concat(textarea.scrollHeight, "px");
      if ($(this).val().trim().length > 10) {
        $('.messages--ai').addClass('active');
      } else {
        $('.messages--ai').hide();
      }
    }).on('click', '.send-media__btn', function (event) {
      event.preventDefault();
      $('.send-media-tooltip').toggleClass('active');
    }).on('click', '.upload-msg-photo-btn', function (e) {
      e.preventDefault();
      $('.upload-photo__text-photo').show();
      $('.upload-photo__text-video').hide();
      $('.upload-photo__text').find('a').removeClass('upload-msg-video-btn').addClass('upload-msg-photo-btn');
      Messages.selectFiles($(this));
    }).on('click', '.upload-msg-video-btn', function (e) {
      e.preventDefault();
      $('.upload-photo__text-photo').hide();
      $('.upload-photo__text-video').show();
      $('.upload-photo__text').find('a').removeClass('upload-msg-photo-btn').addClass('upload-msg-video-btn');
      Messages.selectVideo($(this));
    }).on('click', '.media-popup__close', function (e) {
      e.preventDefault();
      $('.media-popup').css('display', 'none');
    }).on('click', '.media-content', function (e) {
      e.preventDefault();
      var id = $(this).closest('.message-item').attr('data-id');
      $('.media-popup__container').html('');
      Messages.ajax.fetchMedia(id);
    }).on('click', 'ul.upload > li[data-id] > span.remove-upload-msg-photo', function (e) {
      e.preventDefault();
      Messages.files.remove($(this).closest('li[data-id]').data('id'), Messages.typeImages);
      $('.upload-photo__block').show();
      $('.upload-photo-btn').show();
    }).on('click', 'ul.upload > li[data-id] > span.remove-upload-msg-video', function (e) {
      e.preventDefault();
      Messages.files.remove($(this).closest('li[data-id]').data('id'), Messages.typeVideos);
      $('.upload-photo__block').show();
      $('.upload-photo-btn').show();
    }).on('click', '.close-msg-photo-btn', function (e) {
      e.preventDefault();
      $('.popup-bg-opacity--media').css('display', 'none');
      Messages.files.list = [];
      Messages.previewFiles = [];
    }).on('click', '.show-member-contact-details', function (e) {
      e.preventDefault();
      var text = $(this).text();
      var alternateText = $(this).attr('data-alternate-text');
      $(this).text(alternateText);
      $(this).attr('data-alternate-text', text);
      $('.member-contact-details').toggle();
    }).on('click', '.message--ai--popup__close', function (e) {
      e.preventDefault();
      $('.message--ai--popup').removeClass('active');
    }).on('click', '.rephrase-user-message', function (e) {
      e.preventDefault();
      $('.message--ai--popup').addClass('active');
      $('.message--ai--popup__step_1').css('display', 'flex');
      $('.message--ai--popup__step_2').hide();
      $('.message--ai--popup__step_3').hide();

      // setTimeout(function () {
      Messages.ajax.rephraseUserMessage($('.messages__send').val().trim());
      // }, 750);
    }).on('click', '.select-rephrased-user-message', function (e) {
      e.preventDefault();
      $('.message--ai--popup').removeClass('active');
      // $('.messages--ai').removeClass('active');
      var newText = $('.message--ai--popup__step_2').find('textarea').val().trim();
      if (newText.length > 0) {
        var textarea = document.querySelector('.messages__send');
        $('.messages__send').val(newText);
        textarea.style.height = "".concat(textarea.scrollHeight, "px");
      }
    }).on('click', '.message--ai--error--popup__close', function (e) {
      e.preventDefault();
      $('.message--ai--error--popup').removeClass('active');
    }).on('click', '.agree-with-ai-message-restriction', function (e) {
      e.preventDefault();
      var messageID = $(this).closest('.message-item').attr('data-id');
      var userID = $(this).attr('data-user');
      Messages.ajax.agreeWithAiMessageRestriction(messageID, userID);
    }).on('click', '.disagree-with-ai-message-restriction', function (e) {
      e.preventDefault();
      var messageID = $(this).closest('.message-item').attr('data-id');
      $('.message--ai--error--popup').addClass('active');
      $('#disagree-with-ai-message-restriction-submit').attr('data-id', messageID);
    }).on('click', '#disagree-with-ai-message-restriction-submit', function (e) {
      e.preventDefault();
      var userID = $(this).attr('data-user');
      var messageID = $(this).attr('data-id');
      var reason = $('#disagree-with-ai-message-restriction-text').val();
      $('.message--ai--error--popup').addClass('active');
      if (reason.trim().length > 10) {
        Messages.ajax.disagreeWithAiMessageRestriction(messageID, userID, reason);
      } else {
        $('#disagree-with-ai-message-restriction-text').closest('.form-element').find('.error').css('display', 'flex');
        setTimeout(function () {
          $('#disagree-with-ai-message-restriction-text').closest('.form-element').find('.error').hide();
        }, 1500);
      }
    });
  },
  initMessagePagination: function initMessagePagination() {
    // Messages.pagination.status = 1;
    //
    // $('.chat__container').scroll(function() {
    //     if ($('.chat__container').scrollTop() === 0) {
    //         if (Messages.pagination.status === 1) {
    //             ++Messages.pagination.page;
    //             Messages.pagination.status = 0;
    //             Messages.ajax.openNextPage();
    //         }
    //     }
    // });
  },
  popupDownloadOurAppsMessenger: function popupDownloadOurAppsMessenger() {
    var cookie = Main.readCookie('moovick-download-our-app-popup-messenger');
    if (cookie) {
      if (cookie === '1') {
        $(".messages-download-app").css('display', 'none');
      } else {
        $(".messages-download-app").css('display', 'flex');
      }
    } else {
      Main.createCookie('moovick-download-our-app-popup-messenger', 0, 7);
      $(".messages-download-app").css('display', 'flex');
    }
  },
  scrollToLastMessage: function scrollToLastMessage() {
    var chat = document.getElementById('chat-messages');
    if (chat) {
      chat.scrollTo(0, 9999999);
    }
  },
  getDateForMessage: function getDateForMessage(date) {
    var newDate = new Date(date * 1000);
    return dateFormat(newDate, "UTC:dd/mm/yyyy HH:MM");
  },
  receiveMessage: function receiveMessage(data) {
    var chatID = data.chatID;
    var messageID = data.id;
    var text = data.text;
    var translatedText = data.translatedText;
    var elapsedTime = data.elapsedTime;
    var photo = $('.preview-in-chat').html();
    var date = Messages.getDateForMessage(data.createdAt);
    var type = parseInt(data.type);
    var media = data.files;
    var translateButtonCheck = data.translateButtonCheck;
    var translateButtonText = data.translateButtonText;
    var translateLang = data.translateLang;
    Messages.test = media;
    var html = '';
    if (type === Messages.typeImages && media.length !== 0 || text.length > 0) {
      html += "\n            <div class=\"message-item messages-to\" data-id=\"".concat(messageID, "\">\n                <div class=\"messages--block\">\n                    <div class=\"photo\">").concat(photo, "</div>\n                    <div class=\"messages\">");
      if (type === Messages.typeImages) {
        html += '<div class="messages__item messages-media">' + '<div class="media-content">';
        $.each(media, function (key, link) {
          html += "<img src=\"".concat(link, "\">");
        });
        if (media.length > 1) {
          html += "<div class=\"counter\">\n                                            <p>+".concat(media.length, "</p>\n                                        </div>");
        }
        html += '</div>';
      } else if (type === Messages.typeVideos) {
        html += '<div class="messages__item messages-media">' + '<div class="media-content">';
        $.each(media, function (key, link) {
          html += "<video class=\"media-content__item video-muted\" src=\"".concat(link, "\"></video>");
        });
        html += "<div class=\"play\">\n                                <img class=\"play__icon\" src=\"/images/icon/video-play.svg\">\n                            </div>";
        html += '</div>';
      } else {
        html += "\n                                <div class=\"messages__item\">\n                                    <p>".concat(text, "</p>");
        if (text !== '' && text !== translatedText) {
          html += "<p class=\"translator\" data-translate-id=\"".concat(messageID, "\">").concat(translatedText, "</p>");
        } else {
          html += "<p class=\"translator\" data-translate-id=\"".concat(messageID, "\"></p>");
        }
      }
      html += "<div class=\"time\">\n                           <span>".concat(date, "</span>\n            \n                            <div class=\"time__icons\" style=\"display: none\">\n                                <img class=\"time__icon active\" src=\"/images/icon/checked.png\" alt=\"icon\">\n                                <img class=\"time__icon\" src=\"/images/icon/check.png\" alt=\"icon\">\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>");
      if (translateButtonCheck) {
        if (false) {
          html += "<div class=\"translations show-translation-button\" data-translate=\"".concat(messageID, "\" data-text=\"").concat(text, "\" data-lang=\"").concat(translateLang, "\">\n                        <svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#1F3470\"/><path d=\"M11.8463 19.2577H11.9952C13.8644 19.2029 15.6417 18.4342 16.9619 17.1097C18.282 15.7852 19.0448 14.0054 19.0935 12.136C19.1176 10.9929 18.869 9.86041 18.3681 8.83255C17.6568 7.36787 16.4732 6.1853 15.0078 5.47536C13.5425 4.76543 11.8808 4.56948 10.2906 4.91908C8.70029 5.26868 7.27401 6.14347 6.24154 7.40252C5.20906 8.66156 4.63051 10.2315 4.5991 11.8595C4.57987 12.8236 4.75307 13.7819 5.10858 14.6783C5.46409 15.5746 5.99476 16.3911 6.66956 17.08C7.34436 17.7689 8.14975 18.3163 9.03861 18.6902C9.92748 19.0641 10.882 19.257 11.8463 19.2577ZM13.146 18.4792C14.0038 17.8405 14.717 17.0279 15.2391 16.0946C15.6103 16.3196 15.9587 16.5804 16.2793 16.8732C15.3984 17.682 14.3149 18.237 13.1438 18.4792H13.146ZM16.7387 16.4158C16.3708 16.0767 15.9688 15.7766 15.539 15.5203C16.001 14.5173 16.2605 13.433 16.3027 12.3296H18.4404C18.3623 13.8474 17.761 15.2913 16.7387 16.4158ZM17.8023 9.11546C18.1915 9.91299 18.4137 10.7816 18.4553 11.668H16.2984C16.266 10.5928 16.0239 9.53424 15.5858 8.55177C15.573 8.52199 15.5582 8.49433 15.5454 8.46455C15.9725 8.20892 16.3724 7.91028 16.7387 7.57328C17.1608 8.0341 17.514 8.55353 17.7874 9.11546H17.8023ZM16.3027 7.1202C15.9782 7.41383 15.6255 7.67461 15.2497 7.89873C14.7371 6.9782 14.0397 6.17361 13.2013 5.53547C14.3526 5.7801 15.418 6.32711 16.2878 7.1202H16.3027ZM12.1547 5.62056C13.2123 6.24315 14.0852 7.13588 14.6839 8.20717C13.8921 8.58715 13.032 8.80416 12.1547 8.84531V5.62056ZM12.1547 9.50047C13.1334 9.45896 14.0932 9.21792 14.9753 8.79214C14.9753 8.80702 14.9902 8.82192 14.9966 8.83468C15.395 9.7321 15.6181 10.6974 15.6539 11.6787H12.1547V9.50047ZM12.1547 12.3338H15.6496C15.6091 13.3291 15.3765 14.307 14.9647 15.214C14.0848 14.7937 13.129 14.5556 12.1547 14.5142V12.3338ZM12.1547 15.1693C13.027 15.2123 13.8818 15.4293 14.669 15.8075C14.0728 16.8668 13.2049 17.7479 12.1547 18.36V15.1693ZM7.37928 16.8753C7.70611 16.5756 8.06245 16.3098 8.44285 16.0819C8.97296 17.0264 9.69808 17.8472 10.57 18.4898C9.37663 18.2598 8.2714 17.7006 7.37928 16.8753ZM11.5038 18.343C10.4628 17.7227 9.60477 16.8375 9.01718 15.7777C9.79929 15.4091 10.6465 15.1988 11.5102 15.1587L11.5038 18.343ZM11.5038 14.5142C10.5382 14.5548 9.59051 14.7891 8.71725 15.2034C8.30706 14.296 8.07524 13.3182 8.03444 12.3232H11.5102L11.5038 14.5142ZM11.5038 11.6787H8.03869C8.07109 10.6936 8.29431 9.72412 8.69598 8.82404C8.69598 8.82404 8.69598 8.8049 8.71087 8.79426C9.58745 9.21273 10.5397 9.44934 11.5102 9.48984L11.5038 11.6787ZM11.5038 8.84319C10.6345 8.80401 9.78182 8.59138 8.99591 8.21781C9.58799 7.14377 10.4559 6.24718 11.5102 5.62056L11.5038 8.84319ZM10.4892 5.53547C9.65152 6.17896 8.95502 6.98769 8.44285 7.9115C8.07522 7.68907 7.72976 7.43193 7.41119 7.1436C8.27626 6.34387 9.33863 5.78882 10.4892 5.53547ZM6.95385 7.60306C7.32028 7.9381 7.72016 8.23462 8.14718 8.48795C8.14718 8.51348 8.12378 8.53688 8.11314 8.5624C7.67536 9.54508 7.43262 10.6034 7.39842 11.6787H5.25213C5.33402 10.1649 5.93499 8.7256 6.95385 7.60306ZM7.40268 12.3232C7.44302 13.4262 7.70035 14.5104 8.15994 15.5139C7.72278 15.7739 7.31362 16.0782 6.93896 16.4222C5.91661 15.2939 5.32003 13.8443 5.25213 12.3232H7.40268Z\" fill=\"white\"/><path d=\"M21.6969 12.2151L21.0587 12.2044C21.0839 10.9608 20.8609 9.72453 20.4027 8.56803C19.9446 7.41153 19.2605 6.35795 18.3904 5.4689C17.5204 4.57985 16.4819 3.87315 15.3355 3.39011C14.1892 2.90708 12.9581 2.6574 11.7142 2.65568H11.4887C9.05989 2.70335 6.74602 3.69882 5.0413 5.42948L5.01152 5.455H6.4835V6.09315H4.35636C4.27097 6.09258 4.18928 6.05827 4.1291 5.9977C4.06893 5.93712 4.03515 5.8552 4.03516 5.76982V3.63204H4.6733V4.87855C6.4882 3.08211 8.92486 2.05306 11.478 2.00477H11.5993C11.6302 1.99841 11.662 1.99841 11.6929 2.00477H11.7439C13.0707 2.01212 14.3827 2.28313 15.6038 2.80205C16.8248 3.32097 17.9306 4.07745 18.8567 5.02751C19.7828 5.97756 20.5108 7.10224 20.9984 8.33615C21.4859 9.57006 21.7234 10.8886 21.6969 12.2151Z\" fill=\"white\"/><path d=\"M19.6637 18.2279V20.3721H19.0256V19.1256C17.2102 20.9223 14.7724 21.9507 12.2187 21.9972H12.0953L12.0613 21.9994H12.0102H11.9592C10.6321 21.9926 9.31958 21.722 8.09803 21.2033C6.87647 20.6846 5.77024 19.9282 4.84368 18.9781C3.91713 18.028 3.18874 16.9032 2.70089 15.669C2.21304 14.4348 1.97547 13.1159 2.002 11.7891L2.64014 11.8018C2.61471 13.0448 2.83717 14.2804 3.29452 15.4364C3.75188 16.5925 4.43497 17.6458 5.30391 18.535C6.17285 19.4241 7.21022 20.1312 8.35546 20.615C9.50069 21.0988 10.7308 21.3496 11.9741 21.3527H12.1315C12.1549 21.3527 12.1783 21.3527 12.1995 21.3527C14.6317 21.3071 16.9492 20.3106 18.6554 18.5768C18.665 18.567 18.6757 18.5584 18.6873 18.5513H17.2154V17.9131H19.3425C19.4266 17.9131 19.5073 17.9461 19.5674 18.0049C19.6274 18.0638 19.662 18.1439 19.6637 18.2279Z\" fill=\"white\"/></svg>\n                        <p>").concat(translateButtonText, "</p>\n                    </div>");
          html += "<div class=\"translations show-translation-button\" data-translate=\"".concat(messageID, "\" data-text=\"").concat(text, "\" data-lang=\"").concat(translateLang, "\" data-text-stage-1=\"").concat(Messages.translationsBtnTextStage1, "\" data-text-stage-2=\"").concat(Messages.translationsBtnTextStage1, "\">\n                        <svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#1F3470\"/><path d=\"M11.8463 19.2577H11.9952C13.8644 19.2029 15.6417 18.4342 16.9619 17.1097C18.282 15.7852 19.0448 14.0054 19.0935 12.136C19.1176 10.9929 18.869 9.86041 18.3681 8.83255C17.6568 7.36787 16.4732 6.1853 15.0078 5.47536C13.5425 4.76543 11.8808 4.56948 10.2906 4.91908C8.70029 5.26868 7.27401 6.14347 6.24154 7.40252C5.20906 8.66156 4.63051 10.2315 4.5991 11.8595C4.57987 12.8236 4.75307 13.7819 5.10858 14.6783C5.46409 15.5746 5.99476 16.3911 6.66956 17.08C7.34436 17.7689 8.14975 18.3163 9.03861 18.6902C9.92748 19.0641 10.882 19.257 11.8463 19.2577ZM13.146 18.4792C14.0038 17.8405 14.717 17.0279 15.2391 16.0946C15.6103 16.3196 15.9587 16.5804 16.2793 16.8732C15.3984 17.682 14.3149 18.237 13.1438 18.4792H13.146ZM16.7387 16.4158C16.3708 16.0767 15.9688 15.7766 15.539 15.5203C16.001 14.5173 16.2605 13.433 16.3027 12.3296H18.4404C18.3623 13.8474 17.761 15.2913 16.7387 16.4158ZM17.8023 9.11546C18.1915 9.91299 18.4137 10.7816 18.4553 11.668H16.2984C16.266 10.5928 16.0239 9.53424 15.5858 8.55177C15.573 8.52199 15.5582 8.49433 15.5454 8.46455C15.9725 8.20892 16.3724 7.91028 16.7387 7.57328C17.1608 8.0341 17.514 8.55353 17.7874 9.11546H17.8023ZM16.3027 7.1202C15.9782 7.41383 15.6255 7.67461 15.2497 7.89873C14.7371 6.9782 14.0397 6.17361 13.2013 5.53547C14.3526 5.7801 15.418 6.32711 16.2878 7.1202H16.3027ZM12.1547 5.62056C13.2123 6.24315 14.0852 7.13588 14.6839 8.20717C13.8921 8.58715 13.032 8.80416 12.1547 8.84531V5.62056ZM12.1547 9.50047C13.1334 9.45896 14.0932 9.21792 14.9753 8.79214C14.9753 8.80702 14.9902 8.82192 14.9966 8.83468C15.395 9.7321 15.6181 10.6974 15.6539 11.6787H12.1547V9.50047ZM12.1547 12.3338H15.6496C15.6091 13.3291 15.3765 14.307 14.9647 15.214C14.0848 14.7937 13.129 14.5556 12.1547 14.5142V12.3338ZM12.1547 15.1693C13.027 15.2123 13.8818 15.4293 14.669 15.8075C14.0728 16.8668 13.2049 17.7479 12.1547 18.36V15.1693ZM7.37928 16.8753C7.70611 16.5756 8.06245 16.3098 8.44285 16.0819C8.97296 17.0264 9.69808 17.8472 10.57 18.4898C9.37663 18.2598 8.2714 17.7006 7.37928 16.8753ZM11.5038 18.343C10.4628 17.7227 9.60477 16.8375 9.01718 15.7777C9.79929 15.4091 10.6465 15.1988 11.5102 15.1587L11.5038 18.343ZM11.5038 14.5142C10.5382 14.5548 9.59051 14.7891 8.71725 15.2034C8.30706 14.296 8.07524 13.3182 8.03444 12.3232H11.5102L11.5038 14.5142ZM11.5038 11.6787H8.03869C8.07109 10.6936 8.29431 9.72412 8.69598 8.82404C8.69598 8.82404 8.69598 8.8049 8.71087 8.79426C9.58745 9.21273 10.5397 9.44934 11.5102 9.48984L11.5038 11.6787ZM11.5038 8.84319C10.6345 8.80401 9.78182 8.59138 8.99591 8.21781C9.58799 7.14377 10.4559 6.24718 11.5102 5.62056L11.5038 8.84319ZM10.4892 5.53547C9.65152 6.17896 8.95502 6.98769 8.44285 7.9115C8.07522 7.68907 7.72976 7.43193 7.41119 7.1436C8.27626 6.34387 9.33863 5.78882 10.4892 5.53547ZM6.95385 7.60306C7.32028 7.9381 7.72016 8.23462 8.14718 8.48795C8.14718 8.51348 8.12378 8.53688 8.11314 8.5624C7.67536 9.54508 7.43262 10.6034 7.39842 11.6787H5.25213C5.33402 10.1649 5.93499 8.7256 6.95385 7.60306ZM7.40268 12.3232C7.44302 13.4262 7.70035 14.5104 8.15994 15.5139C7.72278 15.7739 7.31362 16.0782 6.93896 16.4222C5.91661 15.2939 5.32003 13.8443 5.25213 12.3232H7.40268Z\" fill=\"white\"/><path d=\"M21.6969 12.2151L21.0587 12.2044C21.0839 10.9608 20.8609 9.72453 20.4027 8.56803C19.9446 7.41153 19.2605 6.35795 18.3904 5.4689C17.5204 4.57985 16.4819 3.87315 15.3355 3.39011C14.1892 2.90708 12.9581 2.6574 11.7142 2.65568H11.4887C9.05989 2.70335 6.74602 3.69882 5.0413 5.42948L5.01152 5.455H6.4835V6.09315H4.35636C4.27097 6.09258 4.18928 6.05827 4.1291 5.9977C4.06893 5.93712 4.03515 5.8552 4.03516 5.76982V3.63204H4.6733V4.87855C6.4882 3.08211 8.92486 2.05306 11.478 2.00477H11.5993C11.6302 1.99841 11.662 1.99841 11.6929 2.00477H11.7439C13.0707 2.01212 14.3827 2.28313 15.6038 2.80205C16.8248 3.32097 17.9306 4.07745 18.8567 5.02751C19.7828 5.97756 20.5108 7.10224 20.9984 8.33615C21.4859 9.57006 21.7234 10.8886 21.6969 12.2151Z\" fill=\"white\"/><path d=\"M19.6637 18.2279V20.3721H19.0256V19.1256C17.2102 20.9223 14.7724 21.9507 12.2187 21.9972H12.0953L12.0613 21.9994H12.0102H11.9592C10.6321 21.9926 9.31958 21.722 8.09803 21.2033C6.87647 20.6846 5.77024 19.9282 4.84368 18.9781C3.91713 18.028 3.18874 16.9032 2.70089 15.669C2.21304 14.4348 1.97547 13.1159 2.002 11.7891L2.64014 11.8018C2.61471 13.0448 2.83717 14.2804 3.29452 15.4364C3.75188 16.5925 4.43497 17.6458 5.30391 18.535C6.17285 19.4241 7.21022 20.1312 8.35546 20.615C9.50069 21.0988 10.7308 21.3496 11.9741 21.3527H12.1315C12.1549 21.3527 12.1783 21.3527 12.1995 21.3527C14.6317 21.3071 16.9492 20.3106 18.6554 18.5768C18.665 18.567 18.6757 18.5584 18.6873 18.5513H17.2154V17.9131H19.3425C19.4266 17.9131 19.5073 17.9461 19.5674 18.0049C19.6274 18.0638 19.662 18.1439 19.6637 18.2279Z\" fill=\"white\"/></svg>\n                        <p>").concat(translateButtonText, "</p>\n                    </div>");
        }
        if (translateLang) {
          html += "<div class=\"translations turn-on-auto-translations\" data-action=\"1\">\n                        <svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#1F3470\"/><path d=\"M11.8463 19.2577H11.9952C13.8644 19.2029 15.6417 18.4342 16.9619 17.1097C18.282 15.7852 19.0448 14.0054 19.0935 12.136C19.1176 10.9929 18.869 9.86041 18.3681 8.83255C17.6568 7.36787 16.4732 6.1853 15.0078 5.47536C13.5425 4.76543 11.8808 4.56948 10.2906 4.91908C8.70029 5.26868 7.27401 6.14347 6.24154 7.40252C5.20906 8.66156 4.63051 10.2315 4.5991 11.8595C4.57987 12.8236 4.75307 13.7819 5.10858 14.6783C5.46409 15.5746 5.99476 16.3911 6.66956 17.08C7.34436 17.7689 8.14975 18.3163 9.03861 18.6902C9.92748 19.0641 10.882 19.257 11.8463 19.2577ZM13.146 18.4792C14.0038 17.8405 14.717 17.0279 15.2391 16.0946C15.6103 16.3196 15.9587 16.5804 16.2793 16.8732C15.3984 17.682 14.3149 18.237 13.1438 18.4792H13.146ZM16.7387 16.4158C16.3708 16.0767 15.9688 15.7766 15.539 15.5203C16.001 14.5173 16.2605 13.433 16.3027 12.3296H18.4404C18.3623 13.8474 17.761 15.2913 16.7387 16.4158ZM17.8023 9.11546C18.1915 9.91299 18.4137 10.7816 18.4553 11.668H16.2984C16.266 10.5928 16.0239 9.53424 15.5858 8.55177C15.573 8.52199 15.5582 8.49433 15.5454 8.46455C15.9725 8.20892 16.3724 7.91028 16.7387 7.57328C17.1608 8.0341 17.514 8.55353 17.7874 9.11546H17.8023ZM16.3027 7.1202C15.9782 7.41383 15.6255 7.67461 15.2497 7.89873C14.7371 6.9782 14.0397 6.17361 13.2013 5.53547C14.3526 5.7801 15.418 6.32711 16.2878 7.1202H16.3027ZM12.1547 5.62056C13.2123 6.24315 14.0852 7.13588 14.6839 8.20717C13.8921 8.58715 13.032 8.80416 12.1547 8.84531V5.62056ZM12.1547 9.50047C13.1334 9.45896 14.0932 9.21792 14.9753 8.79214C14.9753 8.80702 14.9902 8.82192 14.9966 8.83468C15.395 9.7321 15.6181 10.6974 15.6539 11.6787H12.1547V9.50047ZM12.1547 12.3338H15.6496C15.6091 13.3291 15.3765 14.307 14.9647 15.214C14.0848 14.7937 13.129 14.5556 12.1547 14.5142V12.3338ZM12.1547 15.1693C13.027 15.2123 13.8818 15.4293 14.669 15.8075C14.0728 16.8668 13.2049 17.7479 12.1547 18.36V15.1693ZM7.37928 16.8753C7.70611 16.5756 8.06245 16.3098 8.44285 16.0819C8.97296 17.0264 9.69808 17.8472 10.57 18.4898C9.37663 18.2598 8.2714 17.7006 7.37928 16.8753ZM11.5038 18.343C10.4628 17.7227 9.60477 16.8375 9.01718 15.7777C9.79929 15.4091 10.6465 15.1988 11.5102 15.1587L11.5038 18.343ZM11.5038 14.5142C10.5382 14.5548 9.59051 14.7891 8.71725 15.2034C8.30706 14.296 8.07524 13.3182 8.03444 12.3232H11.5102L11.5038 14.5142ZM11.5038 11.6787H8.03869C8.07109 10.6936 8.29431 9.72412 8.69598 8.82404C8.69598 8.82404 8.69598 8.8049 8.71087 8.79426C9.58745 9.21273 10.5397 9.44934 11.5102 9.48984L11.5038 11.6787ZM11.5038 8.84319C10.6345 8.80401 9.78182 8.59138 8.99591 8.21781C9.58799 7.14377 10.4559 6.24718 11.5102 5.62056L11.5038 8.84319ZM10.4892 5.53547C9.65152 6.17896 8.95502 6.98769 8.44285 7.9115C8.07522 7.68907 7.72976 7.43193 7.41119 7.1436C8.27626 6.34387 9.33863 5.78882 10.4892 5.53547ZM6.95385 7.60306C7.32028 7.9381 7.72016 8.23462 8.14718 8.48795C8.14718 8.51348 8.12378 8.53688 8.11314 8.5624C7.67536 9.54508 7.43262 10.6034 7.39842 11.6787H5.25213C5.33402 10.1649 5.93499 8.7256 6.95385 7.60306ZM7.40268 12.3232C7.44302 13.4262 7.70035 14.5104 8.15994 15.5139C7.72278 15.7739 7.31362 16.0782 6.93896 16.4222C5.91661 15.2939 5.32003 13.8443 5.25213 12.3232H7.40268Z\" fill=\"white\"/><path d=\"M21.6969 12.2151L21.0587 12.2044C21.0839 10.9608 20.8609 9.72453 20.4027 8.56803C19.9446 7.41153 19.2605 6.35795 18.3904 5.4689C17.5204 4.57985 16.4819 3.87315 15.3355 3.39011C14.1892 2.90708 12.9581 2.6574 11.7142 2.65568H11.4887C9.05989 2.70335 6.74602 3.69882 5.0413 5.42948L5.01152 5.455H6.4835V6.09315H4.35636C4.27097 6.09258 4.18928 6.05827 4.1291 5.9977C4.06893 5.93712 4.03515 5.8552 4.03516 5.76982V3.63204H4.6733V4.87855C6.4882 3.08211 8.92486 2.05306 11.478 2.00477H11.5993C11.6302 1.99841 11.662 1.99841 11.6929 2.00477H11.7439C13.0707 2.01212 14.3827 2.28313 15.6038 2.80205C16.8248 3.32097 17.9306 4.07745 18.8567 5.02751C19.7828 5.97756 20.5108 7.10224 20.9984 8.33615C21.4859 9.57006 21.7234 10.8886 21.6969 12.2151Z\" fill=\"white\"/><path d=\"M19.6637 18.2279V20.3721H19.0256V19.1256C17.2102 20.9223 14.7724 21.9507 12.2187 21.9972H12.0953L12.0613 21.9994H12.0102H11.9592C10.6321 21.9926 9.31958 21.722 8.09803 21.2033C6.87647 20.6846 5.77024 19.9282 4.84368 18.9781C3.91713 18.028 3.18874 16.9032 2.70089 15.669C2.21304 14.4348 1.97547 13.1159 2.002 11.7891L2.64014 11.8018C2.61471 13.0448 2.83717 14.2804 3.29452 15.4364C3.75188 16.5925 4.43497 17.6458 5.30391 18.535C6.17285 19.4241 7.21022 20.1312 8.35546 20.615C9.50069 21.0988 10.7308 21.3496 11.9741 21.3527H12.1315C12.1549 21.3527 12.1783 21.3527 12.1995 21.3527C14.6317 21.3071 16.9492 20.3106 18.6554 18.5768C18.665 18.567 18.6757 18.5584 18.6873 18.5513H17.2154V17.9131H19.3425C19.4266 17.9131 19.5073 17.9461 19.5674 18.0049C19.6274 18.0638 19.662 18.1439 19.6637 18.2279Z\" fill=\"white\"/></svg>\n                        <p>".concat(translateButtonText, "</p>\n                    </div>");
        } else {
          html += "<div class=\"translations openPopupChooseLanguage\" data-action=\"1\">\n                        <svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#1F3470\"/><path d=\"M11.8463 19.2577H11.9952C13.8644 19.2029 15.6417 18.4342 16.9619 17.1097C18.282 15.7852 19.0448 14.0054 19.0935 12.136C19.1176 10.9929 18.869 9.86041 18.3681 8.83255C17.6568 7.36787 16.4732 6.1853 15.0078 5.47536C13.5425 4.76543 11.8808 4.56948 10.2906 4.91908C8.70029 5.26868 7.27401 6.14347 6.24154 7.40252C5.20906 8.66156 4.63051 10.2315 4.5991 11.8595C4.57987 12.8236 4.75307 13.7819 5.10858 14.6783C5.46409 15.5746 5.99476 16.3911 6.66956 17.08C7.34436 17.7689 8.14975 18.3163 9.03861 18.6902C9.92748 19.0641 10.882 19.257 11.8463 19.2577ZM13.146 18.4792C14.0038 17.8405 14.717 17.0279 15.2391 16.0946C15.6103 16.3196 15.9587 16.5804 16.2793 16.8732C15.3984 17.682 14.3149 18.237 13.1438 18.4792H13.146ZM16.7387 16.4158C16.3708 16.0767 15.9688 15.7766 15.539 15.5203C16.001 14.5173 16.2605 13.433 16.3027 12.3296H18.4404C18.3623 13.8474 17.761 15.2913 16.7387 16.4158ZM17.8023 9.11546C18.1915 9.91299 18.4137 10.7816 18.4553 11.668H16.2984C16.266 10.5928 16.0239 9.53424 15.5858 8.55177C15.573 8.52199 15.5582 8.49433 15.5454 8.46455C15.9725 8.20892 16.3724 7.91028 16.7387 7.57328C17.1608 8.0341 17.514 8.55353 17.7874 9.11546H17.8023ZM16.3027 7.1202C15.9782 7.41383 15.6255 7.67461 15.2497 7.89873C14.7371 6.9782 14.0397 6.17361 13.2013 5.53547C14.3526 5.7801 15.418 6.32711 16.2878 7.1202H16.3027ZM12.1547 5.62056C13.2123 6.24315 14.0852 7.13588 14.6839 8.20717C13.8921 8.58715 13.032 8.80416 12.1547 8.84531V5.62056ZM12.1547 9.50047C13.1334 9.45896 14.0932 9.21792 14.9753 8.79214C14.9753 8.80702 14.9902 8.82192 14.9966 8.83468C15.395 9.7321 15.6181 10.6974 15.6539 11.6787H12.1547V9.50047ZM12.1547 12.3338H15.6496C15.6091 13.3291 15.3765 14.307 14.9647 15.214C14.0848 14.7937 13.129 14.5556 12.1547 14.5142V12.3338ZM12.1547 15.1693C13.027 15.2123 13.8818 15.4293 14.669 15.8075C14.0728 16.8668 13.2049 17.7479 12.1547 18.36V15.1693ZM7.37928 16.8753C7.70611 16.5756 8.06245 16.3098 8.44285 16.0819C8.97296 17.0264 9.69808 17.8472 10.57 18.4898C9.37663 18.2598 8.2714 17.7006 7.37928 16.8753ZM11.5038 18.343C10.4628 17.7227 9.60477 16.8375 9.01718 15.7777C9.79929 15.4091 10.6465 15.1988 11.5102 15.1587L11.5038 18.343ZM11.5038 14.5142C10.5382 14.5548 9.59051 14.7891 8.71725 15.2034C8.30706 14.296 8.07524 13.3182 8.03444 12.3232H11.5102L11.5038 14.5142ZM11.5038 11.6787H8.03869C8.07109 10.6936 8.29431 9.72412 8.69598 8.82404C8.69598 8.82404 8.69598 8.8049 8.71087 8.79426C9.58745 9.21273 10.5397 9.44934 11.5102 9.48984L11.5038 11.6787ZM11.5038 8.84319C10.6345 8.80401 9.78182 8.59138 8.99591 8.21781C9.58799 7.14377 10.4559 6.24718 11.5102 5.62056L11.5038 8.84319ZM10.4892 5.53547C9.65152 6.17896 8.95502 6.98769 8.44285 7.9115C8.07522 7.68907 7.72976 7.43193 7.41119 7.1436C8.27626 6.34387 9.33863 5.78882 10.4892 5.53547ZM6.95385 7.60306C7.32028 7.9381 7.72016 8.23462 8.14718 8.48795C8.14718 8.51348 8.12378 8.53688 8.11314 8.5624C7.67536 9.54508 7.43262 10.6034 7.39842 11.6787H5.25213C5.33402 10.1649 5.93499 8.7256 6.95385 7.60306ZM7.40268 12.3232C7.44302 13.4262 7.70035 14.5104 8.15994 15.5139C7.72278 15.7739 7.31362 16.0782 6.93896 16.4222C5.91661 15.2939 5.32003 13.8443 5.25213 12.3232H7.40268Z\" fill=\"white\"/><path d=\"M21.6969 12.2151L21.0587 12.2044C21.0839 10.9608 20.8609 9.72453 20.4027 8.56803C19.9446 7.41153 19.2605 6.35795 18.3904 5.4689C17.5204 4.57985 16.4819 3.87315 15.3355 3.39011C14.1892 2.90708 12.9581 2.6574 11.7142 2.65568H11.4887C9.05989 2.70335 6.74602 3.69882 5.0413 5.42948L5.01152 5.455H6.4835V6.09315H4.35636C4.27097 6.09258 4.18928 6.05827 4.1291 5.9977C4.06893 5.93712 4.03515 5.8552 4.03516 5.76982V3.63204H4.6733V4.87855C6.4882 3.08211 8.92486 2.05306 11.478 2.00477H11.5993C11.6302 1.99841 11.662 1.99841 11.6929 2.00477H11.7439C13.0707 2.01212 14.3827 2.28313 15.6038 2.80205C16.8248 3.32097 17.9306 4.07745 18.8567 5.02751C19.7828 5.97756 20.5108 7.10224 20.9984 8.33615C21.4859 9.57006 21.7234 10.8886 21.6969 12.2151Z\" fill=\"white\"/><path d=\"M19.6637 18.2279V20.3721H19.0256V19.1256C17.2102 20.9223 14.7724 21.9507 12.2187 21.9972H12.0953L12.0613 21.9994H12.0102H11.9592C10.6321 21.9926 9.31958 21.722 8.09803 21.2033C6.87647 20.6846 5.77024 19.9282 4.84368 18.9781C3.91713 18.028 3.18874 16.9032 2.70089 15.669C2.21304 14.4348 1.97547 13.1159 2.002 11.7891L2.64014 11.8018C2.61471 13.0448 2.83717 14.2804 3.29452 15.4364C3.75188 16.5925 4.43497 17.6458 5.30391 18.535C6.17285 19.4241 7.21022 20.1312 8.35546 20.615C9.50069 21.0988 10.7308 21.3496 11.9741 21.3527H12.1315C12.1549 21.3527 12.1783 21.3527 12.1995 21.3527C14.6317 21.3071 16.9492 20.3106 18.6554 18.5768C18.665 18.567 18.6757 18.5584 18.6873 18.5513H17.2154V17.9131H19.3425C19.4266 17.9131 19.5073 17.9461 19.5674 18.0049C19.6274 18.0638 19.662 18.1439 19.6637 18.2279Z\" fill=\"white\"/></svg>\n                        <p>".concat(translateButtonText, "</p>\n                    </div>");
        }
      }
      html += "</div>";
    }
    if (Messages.chatID === chatID) {
      $('div#chat-messages').append(html);
      Messages.ajax.readMessage(messageID);
      Messages.scrollToLastMessage();
    }
    Messages.playSoundWhenUserReceivedMessage();
    Notify.successfulNotification('You received new message');
    Messages.updateChatPreview(chatID, text, elapsedTime);
  },
  playSoundWhenUserReceivedMessage: function playSoundWhenUserReceivedMessage() {
    var audio = new Audio("/../../audio/get_message.mp3");
    audio.volume = 0.3;
    audio.play();
  },
  updateChatPreview: function updateChatPreview(chatID, text, elapsedTime) {
    var chatBlock = $(".chat__list__item[id=\"".concat(chatID, "\"]"));
    chatBlock.find('.last-message p').html(text.slice(0, 25));
    chatBlock.find('.info').find('span').html(elapsedTime);
    if (Messages.chatID !== chatID) {
      var countBlock = chatBlock.find('.message-count');
      var count = parseInt(countBlock.attr('data-count'));
      var newCount = count + 1;
      countBlock.attr('data-count', newCount);
      countBlock.find('span').html(newCount);
      countBlock.show();
    }
    $('.chat__list-content').animate({
      scrollTop: parseInt(chatBlock.offset().top) - 100
    }, 500);
  },
  updateMessageStatusRead: function updateMessageStatusRead(messageID) {
    console.log('messageID', messageID);
    var timeIcon = $(".message-item[data-id=\"".concat(messageID, "\"]")).find('.time__icon');
    console.log('timeIcon ' + timeIcon);
    timeIcon.removeClass('active');
    timeIcon.first().addClass('active');
  },
  openMiniChat: function openMiniChat(answer) {
    Messages.chatID = answer.chatID;
    Messages.isMiniChat = true;
    $('div.mini-chat').html('');
    setTimeout(function () {
      $('.popup-bg-opacity--chat').addClass('active').show();
      $('div.mini-chat').html(answer.html);
      Messages.ajax.fetchButtons();
      Messages.scrollToLastMessage();
      Main.onShow();
      Messages.popupDownloadOurAppsMessenger();
    }, 300);
  },
  showPopupAfterFirstMessageFromClient: function showPopupAfterFirstMessageFromClient(data) {
    var popup = $('.message-sent');
    var link = popup.find('a').attr('href');
    popup.find('a').attr('href', link + '?hash=' + data.hash);
    popup.addClass('active');
  },
  blockChatModule: function blockChatModule(data) {
    if ($('.messages-page').length) {
      Messages.ajax.openChat($(this));
    } else {
      Messages.ajax.openMiniChat('', Messages.chatID);
    }
  },
  selectVideo: function selectVideo(element) {
    var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $('.send-media-tooltip').removeClass('active');
    $('#send-photos').attr('data-type', Messages.typeVideos);
    $('#upload-msg-photo-btn').attr('data-type', Messages.typeVideos);
    var $input = $('<input type="file" accept=".mov, .mp4" multiple>').on('change', function (event) {
      $('.popup-bg-opacity--media').css('display', 'flex');
      Step.preloaderUpload(event, true);
      $.each(this.files, function (k, v) {
        if (v.size < Step.maxVideoSize && Messages.files.list.length < max) {
          Messages.files.add(v, Messages.typeVideos);
          Messages.previewFiles.push(URL.createObjectURL(event.target.files[k]));
        }
      });
      $input.remove();
      if (Messages.files.list.length > max - 1) {
        $('.upload-photo__block').hide();
        $('.upload-photo-btn').hide();
      } else {
        Step.preloaderUpload(event);
      }
      $('.upload-photo').removeClass('error');
      $('.upload-photo__error').html('');
    }).hide();
    $(document.body).append($input);
    $input.click();
  },
  selectFiles: function selectFiles(element) {
    $('.send-media-tooltip').removeClass('active');
    $('#send-photos').attr('data-type', Messages.typeImages);
    var $input = $('<input type="file" accept=".png, .jpg, .jpeg, .HEIC" multiple>').on('change', function (event) {
      var fileName = this.files[0];
      var fileNameExt = fileName.name.substr(fileName.name.lastIndexOf('.') + 1);
      var preloaderCount = true;
      $('.popup-bg-opacity--media').css('display', 'flex');
      if (fileNameExt == "heic" || fileNameExt == "HEIC") {
        var thisInput = this;
        preloaderCount = false;
        Step.preloaderUpload(event, preloaderCount);
        heic2any({
          blob: fileName,
          toType: "image/jpeg",
          quality: 0.5
        }).then(function (result) {
          var container = new DataTransfer();
          var fileJpeg = new File([result], fileName.name + ".jpg", {
            type: "image/jpeg",
            lastModified: new Date().getTime()
          });
          container.items.add(fileJpeg);
          $.each(thisInput.files, function (k) {
            if (fileJpeg.size < Step.maxFileSize && Driver.files.list.length < 10) {
              Messages.files.add(container.files[0]);
              Messages.previewFiles.push(URL.createObjectURL(result));
            }
          });
        })["catch"](function (x) {
          console.log('Error');
        });
      } else {
        preloaderCount = true;
        Step.preloaderUpload(event, preloaderCount);
        $.each(this.files, function (k, v) {
          if (v.size < Step.maxFileSize && Messages.files.list.length < 10) {
            Messages.files.add(v);
            Messages.previewFiles.push(URL.createObjectURL(event.target.files[k]));
          }
        });
      }
      $input.remove();
      if (Messages.files.list.length > 9) {
        $('.upload-photo__block').hide();
        $('.upload-photo-btn').hide();
      } else {
        Step.preloaderUpload(event);
      }
      $('.upload-photo').removeClass('error');
      $('.upload-photo__error').html('');
    }).hide();
    $(document.body).append($input);
    $input.click();
  },
  openPopupWithMedia: function openPopupWithMedia() {
    $('.media-popup').css('display', 'flex');
    var SwiperMediaSlider = new Swiper('.media-popup__container', {
      wrapperClass: "media-popup__wrapper",
      slideClass: "media-popup__item",
      slidesPerView: 1,
      loop: true,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 1
      }
    });
  },
  files: {
    list: [],
    $fileList: undefined,
    $progress: undefined,
    add: function add(file) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Messages.typeImages;
      this.list.push(file);
      this.refreshList(type);
    },
    remove: function remove(key, type) {
      this.list.splice(key, 1);
      Messages.previewFiles.splice(key, 1);
      this.refreshList(type);
    },
    refreshList: function refreshList(type, callback) {
      this.$fileList = $('.chat-media').find('ul.upload').fadeOut('fast', function () {
        $(this).children('li[data-id]').remove();
        $.each(Messages.files.list, function (k, v) {
          if (type === Messages.typeImages) {
            Messages.files.$fileList.append($('<li>').attr('data-id', k).append($('<img>').attr('src', Messages.previewFiles[k])).append('<span class="upload-photo__remove remove-upload-msg-photo"><svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="10.5" cy="10" rx="10.5" ry="10" fill="white" fill-opacity="0.8"/><path d="M6 5L11 10M16 15L11 10M11 10L16 5M11 10L6 15" stroke="#EB5757" stroke-width="2"/></svg>\n</span>'));
          } else {
            Messages.files.$fileList.append($('<li>').attr('data-id', k).append($('<video controls>').addClass('video-muted').attr('src', Messages.previewFiles[k])).append('<span class="upload-photo__remove remove-upload-msg-video"><svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="10.5" cy="10" rx="10.5" ry="10" fill="white" fill-opacity="0.8"/><path d="M6 5L11 10M16 15L11 10M11 10L16 5M11 10L6 15" stroke="#EB5757" stroke-width="2"/></svg>\n</span>'));
          }
        });
        $(this).fadeIn('fast', function () {
          typeof callback === 'function' ? callback() : null;
        });
      });
    },
    upload: function upload(msgID, type) {
      if (this.list.length > 0) {
        Messages.ajax.uploadPhotos(this.list.shift(), type, msgID);
      } else {
        Main.hidePreloader($('#send-photos'));
        Messages.ajax.getMessage(msgID);
        Messages.ajax.filesUploaded(msgID);
        Messages.files.list = [];
        Messages.previewFiles = [];
        $('.popup-bg-opacity--media').css('display', 'none');
      }
    },
    uploadAllFiles: function uploadAllFiles(msgID, type) {
      if (this.list.length > 0) {
        var formData = new FormData();
        var method = type === Messages.typeImages ? 'uploadPhotos' : 'uploadVideo';
        formData.append('method', method);
        formData.append('id', msgID);
        $.each(this.list, function (i, file) {
          formData.append('file_' + i, file);
        });
        $.ajax({
          url: USER_URL,
          type: 'POST',
          data: formData,
          contentType: false,
          processData: false,
          success: function success() {
            Messages.files.list = [];
            Messages.files.uploadAllFiles(msgID, type);
          },
          error: function error() {
            console.log('Error');
          }
        });
      } else {
        Main.hidePreloader($('#send-photos'));
        Messages.ajax.getMessage(msgID);
        Messages.ajax.filesUploaded(msgID);
        Messages.files.list = [];
        Messages.previewFiles = [];
        $('.popup-bg-opacity--media').css('display', 'none');
      }
    }
  },
  ajax: {
    obj: {},
    url: USER_URL,
    send: function send(success, failure) {
      var _this = this;
      $.post(this.url, this.obj, function (answer) {
        _this.obj = {};
        answer.result && typeof success === 'function' ? success(answer) : !answer.result && typeof failure === 'function' ? failure(answer) : null;
      }, 'JSON');
    },
    nextChatPage: function nextChatPage(button) {
      this.obj.method = 'nextChatPage';
      this.obj.page = Messages.chatPage;
      this.send(function (answer) {
        ++Messages.chatPage;
        $('#load_more_chats').remove();
        $('.chat__list-content').append(answer.html);
        if (parseInt(answer.count) < 6) {
          // $('#load_more_chats').remove();
        } else {
          $('.chat__list__item').last().after('<button class="chat__list-content__more" id="load_more_chats">Load more</button>');
        }

        // $('.tab__messages').addClass('active');
        // $('.messages__window-active').addClass('active');
        // $('.chat__window').removeClass('active');

        Main.hidePreloader(button);
      }, function (answer) {
        button.hide();
        Main.hidePreloader(button);
      });
    },
    openChat: function openChat(chatBlock) {
      this.obj.method = 'openChat';
      this.obj.chatID = Messages.chatID;
      this.send(function (answer) {
        chatBlock.find('.message-count').attr('data-count', 0).hide();
        $('div#chat-window').html(answer.html);
        Messages.scrollToLastMessage();
        Messages.scrollToLastMessage();
        Messages.popupDownloadOurAppsMessenger();
        Messages.initMessagePagination();
        Messages.ajax.fetchButtons();
        Main.showHideBlockByCookies('moovick-chat-info-on-chat-window', $('.messages__content__block').find('.chat-info'), 7);
      });
    },
    fetchButtons: function fetchButtons() {
      this.obj.method = 'fetchButtons';
      this.obj.authorID = $('.chat-buttons-container').attr('data-author');
      this.obj.memberID = $('.chat-buttons-container').attr('data-member');
      this.obj.servicesExist = $('.chat-buttons-container').attr('data-service-exist');
      this.obj.userID = $('.chat-buttons-container').attr('data-user-id');
      this.obj.userPersonalID = $('.chat-buttons-container').attr('data-user-personal-id');
      this.send(function (answer) {
        $('.chat-buttons-container').html(answer.html);
      });
    },
    openNextPage: function openNextPage() {
      this.obj.method = 'openNextPage';
      this.obj.page = Messages.pagination.page;
      this.obj.chatID = Messages.chatID;
      this.send(function (answer) {
        $('.chat__container').prepend(answer.html);
        Messages.pagination.status = 1;
      });
    },
    openMiniChatForOffer: function openMiniChatForOffer(hash, button) {
      this.obj.method = 'openMiniChatForOffer';
      this.obj.offerID = hash;
      this.send(function (answer) {
        Messages.openMiniChat(answer);
        Main.hidePreloader(button);
      }, function () {
        Main.hidePreloader(button);
      });
    },
    openMiniChat: function openMiniChat(userID) {
      var chatHash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.obj.method = 'openMiniChat';
      this.obj.userID = userID;
      this.obj.chatHash = chatHash;
      this.send(function (answer) {
        Messages.openMiniChat(answer);
      }, function (answer) {
        if (!answer.phoneVerification) VerifyPhone.openFirstStep();
      });
    },
    openMiniChatViaHash: function openMiniChatViaHash(hash) {
      this.obj.method = 'openMiniChatViaHash';
      this.obj.hash = hash;
      this.send(function (answer) {
        Messages.openMiniChat(answer);
      }, function () {});
    },
    sendMessage: function sendMessage(button, message, field) {
      this.obj.method = 'sendMessage';
      this.obj.chatID = Messages.chatID;
      this.obj.message = message;
      this.send(function (answer) {
        field.val('');
        field.css('height', '50');
        $('div#chat-messages').append(answer.html);
        Messages.scrollToLastMessage();
        button.prop('disabled', false);
        $('.messages--ai').removeClass('active');
      }, function () {
        button.prop('disabled', false);
      });
    },
    sendPhotos: function sendPhotos(button, type) {
      this.obj.method = type === Messages.typeImages ? 'sendPhotos' : 'sendVideo';
      this.obj.chatID = Messages.chatID;
      this.send(function (answer) {
        Messages.files.uploadAllFiles(answer.messageID, type);
      }, function () {
        Main.hidePreloader(button);
      });
    },
    readMessage: function readMessage(messageID) {
      this.obj.method = 'readMessage';
      this.obj.messageID = messageID;
      this.send(function () {
        Messages.updateMessageStatusRead(messageID);
      });
    },
    fetchMedia: function fetchMedia(messageID) {
      this.obj.method = 'fetchMedia';
      this.obj.messageID = messageID;
      this.send(function (answer) {
        $('.media-popup__container').html(answer.html);
        Messages.openPopupWithMedia();
      });
    },
    filesUploaded: function filesUploaded(messageID) {
      this.obj.method = 'filesUploaded';
      this.obj.messageID = messageID;
      this.send(function () {});
    },
    getMessage: function getMessage(messageID) {
      this.obj.method = 'getMessage';
      this.obj.messageID = messageID;
      this.send(function (answer) {
        $('div#chat-messages').append(answer.html);
        Messages.scrollToLastMessage();
      });
    },
    uploadPhotos: function uploadPhotos(file, type, msgID) {
      var formData = new FormData();
      var method = type === Messages.typeImages ? 'uploadPhotos' : 'uploadVideo';
      formData.append('method', method);
      formData.append('id', msgID);
      formData.append('file', file);
      $.ajax({
        url: USER_URL,
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        success: function success() {
          Messages.files.uploadAllFiles(msgID, type);
        },
        error: function error() {
          console.log('Error');
        }
      });
    },
    rephraseUserMessage: function rephraseUserMessage(text) {
      this.obj.method = 'rephraseUserMessage';
      this.obj.chatHash = Messages.chatID;
      this.obj.text = text;
      this.send(function (answer) {
        if (answer.text.length) {
          $('.message--ai--popup__step_1').hide();
          $('.message--ai--popup__step_2').show();
          $('.message--ai--popup__step_3').hide();
          $('.message--ai--popup__step_2').find('textarea').val(answer.text);
        } else {
          $('.message--ai--popup__step_1').hide();
          $('.message--ai--popup__step_2').hide();
          $('.message--ai--popup__step_3').show();
        }
      }, function (answer) {
        $('.message--ai--popup__step_1').hide();
        $('.message--ai--popup__step_2').hide();
        $('.message--ai--popup__step_3').show();
      });
    },
    agreeWithAiMessageRestriction: function agreeWithAiMessageRestriction(messageID, userID) {
      this.obj.method = 'agreeWithAiMessageRestriction';
      this.obj.userID = userID;
      this.obj.messageID = messageID;
      this.send(function (answer) {
        var message = $("[data-id=\"".concat(messageID, "\"]"));
        var p = message.find('p').first();
        var originalText = p.html();
        p.html(originalText + '<br><br>' + 'Your answer is received. Thank you!');
        message.find('.buttons').remove();
      }, function (answer) {});
    },
    disagreeWithAiMessageRestriction: function disagreeWithAiMessageRestriction(messageID, userID, reason) {
      this.obj.method = 'disagreeWithAiMessageRestriction';
      this.obj.userID = userID;
      this.obj.messageID = messageID;
      this.obj.reason = reason;
      this.send(function (answer) {
        $('.message--ai--error--popup').find('.message--ai--error--popup--block').hide();
        $('.message--ai--error--popup').find('.message--ai--error--popup--done').show();

        // setTimeout(function () {
        //     $('.message--ai--error--popup').removeClass('active');
        // }, 2000);

        var message = $("[data-id=\"".concat(messageID, "\"]"));
        var p = message.find('p').first();
        var originalText = p.html();
        p.html(originalText + '<br><br>' + 'Your answer is received. Thank you!');
        message.find('.buttons').remove();
      }, function (answer) {});
    }
  }
};